import { lazy } from 'react';

const Agents = lazy(() => import('../../admin/agents/AdminAgentsPage'));

const ManagerAgentsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'manager/agents',
      element: <Agents />,
    },
  ],
};

export default ManagerAgentsConfig;
